<!-- 2017-03-30, Alex                                             -->
<!-- We can't use ng-if because this would disrupt the playback.  -->
<div
	[style.display]="screen()?.isHidden ? 'none' : 'flex'"
	style="display: flex; position: relative"
	[class.isFullscreen]="screen()?.isFullScreen"
	(click)="handleScreenClick()"
>
	@if (screen()?.mediaType === "streamable") {
		<video
			class="embed-responsive-item"
			style="width: 100%; z-index: 2"
			#videoPlayer
			[attr.poster]="posterUrl()"
			(ended)="onEnded()"
			(error)="setError($event)"
			[src]="screen()?.url"
		></video>
	}

	@if (screen()?.mediaType === "picture") {
		<img class="embed-responsive-item" [src]="imageUrl" style="width: 100%; position: absolute" title="No Video" />
	}

	@if (settings.axisVideoPlayerEnableDebugWindow) {
		<div class="video-player-debug-container">
			@if (screen()?.isSynchronizationMaster) {
				<strong>IsSynchronizationMaster</strong><br />
			}
			CanPlay: {{ screen()?.canPlay }}<br />
			IsReady: {{ screen()?.isReady }}<br />
			MediaType: {{ screen()?.mediaType }}<br />
			Url: {{ screen()?.url }}<br />
			Position: {{ screen()?.currentTimeInMilliseconds | mmss }}
		</div>
	}
</div>
